import { usePublicCalculatorContext } from '~src/context/PublicCalculatorContext';
import { DeepPartial, NewOfferExpensesInput, Offer } from '~src/model';
import { newOfferPriceWithExpenses } from '~src/util';

type OfferInput = Pick<
  DeepPartial<Offer>,
  'heatPumpOutdoorUnit' | 'heatPumpIndoorUnit' | 'inverter' | 'solarPanel' | 'battery'
>;

export const useNewOfferPriceWithExpenses = (offer?: OfferInput, expenses?: NewOfferExpensesInput) => {
  const { solarPackageDiscount = 0 } = usePublicCalculatorContext();

  const price = newOfferPriceWithExpenses(offer, expenses);

  return price - solarPackageDiscount;
};
